import {useTranslateFunction} from 'contexts/translation/TranslationContext';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import {useState, useEffect, Component} from 'react';

export const StanfordFooter = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return width < 850 ? <StanfordFooterMobile /> : <StanfordFooterBrowser />;
};

const StanfordFooterMobile = () => {
  const t = useTranslateFunction('landing');
  const tCommon = useTranslateFunction('common');
  return (
    <div className="global-footer">
      <div className="d-flex flex-column align-items-center">
        <a href="https://www.stanford.edu" className="pt-4 pb-3">
          <img
            src="https://www-media.stanford.edu/su-identity/images/footer-stanford-logo@2x.png"
            alt={tCommon('Stanford University') as string}
            width="105"
            height="49"
          ></img>
        </a>
        <div className="d-flex justify-content-around" style={{width: '100%'}}>
          <div className="footer-bottom-list">
            <a href="https://www.stanford.edu">{t('Stanford Home')}</a>
            <br />
            <a href="https://visit.stanford.edu/plan/">
              {t('Maps & Directions')}
            </a>
            <br />
            <a href="https://www.stanford.edu/search/">
              {t('Search Stanford')}
            </a>
            <br />
            <a href="https://emergency.stanford.edu">{t('Emergency Info')}</a>
            <br />
          </div>
          <div className="footer-bottom-list">
            <a
              href="https://www.stanford.edu/site/terms/"
              title={t('Terms of use for sites') as string}
            >
              {t('Terms of Use')}
            </a>
            <br />
            <a
              href="https://www.stanford.edu/site/privacy/"
              title={t('Privacy and cookie policy') as string}
            >
              {t('Privacy')}
            </a>
            <br />
            <a
              href="https://uit.stanford.edu/security/copyright-infringement"
              title={t('Report alleged copyright infringement') as string}
            >
              {t('Copyright')}
            </a>
            <br />
            <a
              href="https://adminguide.stanford.edu/chapter-1/subchapter-5/policy-1-5-4"
              title={
                t(
                  'Ownership and use of Stanford trademarks and images',
                ) as string
              }
            >
              {t('Trademarks')}
            </a>
            <br />
            <a
              href="http://exploredegrees.stanford.edu/nonacademicregulations/nondiscrimination/"
              title={t('Non-discrimination policy') as string}
            >
              {t('Non-Discrimination')}
            </a>
            <br />
            <a
              href="https://www.stanford.edu/site/accessibility"
              title={t('Report web accessibility issues') as string}
            >
              {t('Accessibility')}
            </a>
          </div>
        </div>
        <p className="copyright vcard footer-bottom-list-small ">
          © <span className="fn org">{tCommon('Stanford University')}</span>,{' '}
          <span className="adr">
            {' '}
            <span className="locality">Stanford</span>,{' '}
            <span className="region">California</span>{' '}
            <span className="postal-code">94305</span>
          </span>
        </p>
      </div>
    </div>
  );
};

const StanfordFooterBrowser = () => {
  const t = useTranslateFunction('landing');
  const tCommon = useTranslateFunction('common');
  return (
    <div className="global-footer ">
      <div
        className="container footer-container"
        title={t('Common Stanford resources') as string}
      >
        <div className="row">
          <div className="col-md-2 d-none d-md-block">
            <div className="footer-bottom-logo">
              <a href="https://www.stanford.edu">
                <img
                  src="https://www-media.stanford.edu/su-identity/images/footer-stanford-logo@2x.png"
                  alt={tCommon('Stanford University') as string}
                  width="105"
                  height="49"
                ></img>
              </a>
            </div>
          </div>
          <div className="col-md-10 col-12">
            <div className="footer-bottom-text">
              <div className="d-flex footer-bottom-list">
                <a href="https://www.stanford.edu">{t('Stanford Home')}</a>
                <a href="https://visit.stanford.edu/plan/">
                  {t('Maps & Directions')}
                </a>
                <a href="https://www.stanford.edu/search/">
                  {t('Search Stanford')}
                </a>
                <a href="https://emergency.stanford.edu">
                  {t('Emergency Info')}
                </a>
              </div>

              <div className="d-flex footer-bottom-list footer-bottom-list-small">
                <a
                  href="https://www.stanford.edu/site/terms/"
                  title={t('Terms of use for sites') as string}
                >
                  {t('Terms of Use')}
                </a>
                <a
                  href="https://www.stanford.edu/site/privacy/"
                  title={t('Privacy and cookie policy') as string}
                >
                  {t('Privacy')}
                </a>
                <a
                  href="https://uit.stanford.edu/security/copyright-infringement"
                  title={t('Report alleged copyright infringement') as string}
                >
                  {t('Copyright')}
                </a>
                <a
                  href="https://adminguide.stanford.edu/chapter-1/subchapter-5/policy-1-5-4"
                  title={
                    t(
                      'Ownership and use of Stanford trademarks and images',
                    ) as string
                  }
                >
                  {t('Trademarks')}
                </a>
                <a
                  href="http://exploredegrees.stanford.edu/nonacademicregulations/nondiscrimination/"
                  title={t('Non-discrimination policy') as string}
                >
                  {t('Non-Discrimination')}
                </a>
                <a
                  href="https://www.stanford.edu/site/accessibility"
                  title={t('Report web accessibility issues') as string}
                >
                  {t('Accessibility')}
                </a>
              </div>

              <p className="copyright vcard footer-bottom-list-small ">
                ©{' '}
                <span className="fn org">{tCommon('Stanford University')}</span>
                ,{' '}
                <span className="adr">
                  {' '}
                  <span className="locality">Stanford</span>,{' '}
                  <span className="region">California</span>{' '}
                  <span className="postal-code">94305</span>
                </span>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
